<template>
  <div v-if="stockTakeOrders && formater">
    <v-sheet class="hidden-print" style="margin-top: 80px" />
    <MutiplePiecesPrint
      :showSinglePrint="true"
      :formater="formater"
      :datas="stockTakeOrders"
    />
  </div>
</template>
<script>
import StockTakes from "@/api/stock_takes";

import PrintTemplates from "@/api/print_templates";
import MutiplePiecesPrint from "@/components/plugins/print/MutiplePiecesPrint";
import { mapState } from "vuex";

export default {
  components: {
    MutiplePiecesPrint,
  },

  data: () => ({
    formater: null,
    stockTakeOrders: [],
  }),

  computed: {
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["accountInfo"]),
  },

  mounted() {
    PrintTemplates.fetchOne("shopInventoryStockOrderTake").then(
      function (response) {
        if (response.data.status.isOK()) {
          var formater = response.data.print_template.print_template.template;
          this.formater = formater;

          //获取单据详情
          StockTakes.stockTakeOrdersPrint(this.$route.query).then(
            function (response) {
              if (response.data.status.isOK()) {
                this.stockTakeOrders = response.data.stock_takes;
              }
            }.bind(this)
          );
        }
      }.bind(this)
    );
  }

};
</script>
